export const environmentBase = {
  appVersion: '1.2.7',
  buildId: '1.2.7-1',
};
